"use client"

import { useState } from "react"
import KexinHeader from "./Header"
import SearchPanel from "./SearchPanel"
import ResearchSection from "./ResearchSection"
import type { IBus, IData } from "@/types"

export default function Kexin({
  data,
}: {
  data: IData
  lang: string
  bus: IBus
  templateId: string | number
}) {
  const [query, setQuery] = useState("")

  // 点击问题卡片的「用可信分析」: 将问题填入搜索框并滚动回搜索区
  function handleAnalyse(question: string) {
    setQuery(question)
    document.getElementById("kexin-search")?.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden bg-white font-sans text-[#131921]">
      {/* kexin 模板专属 iconfont, 仅在该模板渲染时加载 */}
      <link rel="stylesheet" href="/images/kexin/font_icon/iconfont.css" precedence="default" />
      <KexinHeader logo={data?.homeLogoUrl || data?.logoUrl} />
      <main className="relative flex w-full flex-1 flex-col items-center gap-12 px-4 pb-14 pt-11 md:gap-[72px] md:px-10 md:pb-16 md:pt-[72px] xl:px-16 2xl:gap-20 2xl:px-28 2xl:pt-20">
        <div
          className="pointer-events-none absolute -top-[180px] left-0 right-0 h-[360px]"
          style={{
            background:
              "radial-gradient(ellipse at 50% 50%, rgba(119, 128, 255, 0.16) 0%, rgba(247, 248, 250, 0) 68%)",
          }}
          aria-hidden="true"
        />
        <SearchPanel isExpired={data.expiredFlag} query={query} onQueryChange={setQuery} />
        <ResearchSection onAnalyse={handleAnalyse} />
      </main>
    </div>
  )
}
